import React, { Fragment, useState } from 'react'
import { selectors } from '../features/app'
import { useSelector, useDispatch } from 'react-redux'
import { EAppVersion } from '../features/app/types';

const Header: React.FC = () => {
  const version = useSelector(selectors.getAppVersion);
  const step = useSelector(selectors.getAppStep);
  const back = useSelector(selectors.getAppBack);
  const disabled = true;//useSelector(selectors.getAppIsLoading); // nav doesnt work but not needed anyway
  const stepList = [
    { text: 'Car Specs' },
    { text: 'Condition' },
    { text: 'Your Details' },
    { text: version == EAppVersion.a ? 'Instant Offer' : 'Confirmation' }
  ];
  const [isInit, setIsInit] = useState(false);

  const handleCloseClick = () => {
    (location as any) = back;
  };

  // const handleStepClick = (i: number) => {
  //   if (i < step){
  //     dispatch({ type: actionTypes.SET_APP, payload: {step: i} });
  //   }
  // };

  return (
    <Fragment>
      <header className={`i-header ${step == 3 ? 'i-alt-bg' : ''} ${stepList.length == step+1 ? 'i-completed' : ''}`}>
        <div className="i-con">
          <div className="i-row">
            <div className="i-col i-header-nav">
              <ul className="i-row">
                {stepList.map((s, i) => <li key={i} className={`i-col ${step > i ? 'i-done' : ''} ${step === i ? 'i-active' : ''}`}>
                  <button type="button" 
                    disabled={disabled}
                    // onClick={() => handleStepClick(i)}
                    >
                    <span>{i < 10 ? `0${(i+1).toString()}` : (i+1).toString()}/ </span>
                    <span>{s.text}</span>
                  </button>
                </li>)}
              </ul>
            </div>
            <div className="i-col i-header-close">
              <button type="button" aria-label="close" onClick={handleCloseClick} />
            </div>
          </div>
        </div>
      </header>
    </Fragment>
  )
}

export default Header
